const RedmineIssueHistoryRelations = {
  COPIED_TO: 'copiedTo',
  PRECEDES: 'precedes',
  BLOCKED: 'blocked',
  DUPLICATED: 'duplicated',
  COPIED_FROM: 'copiedFrom',
  BLOCKS: 'blocks',
  FOLLOWS: 'follows',
  DUPLICATES: 'duplicates',
  RELATES: 'relates',
};
export const relationsSelectValues = [
  {
    valueId: RedmineIssueHistoryRelations.COPIED_TO,
  },
  {
    valueId: RedmineIssueHistoryRelations.PRECEDES,
  },
  {
    valueId: RedmineIssueHistoryRelations.BLOCKED,
  },
  {
    valueId: RedmineIssueHistoryRelations.DUPLICATED,
  },
  {
    valueId: RedmineIssueHistoryRelations.COPIED_FROM,
  },
  {
    valueId: RedmineIssueHistoryRelations.BLOCKS,
  },
  {
    valueId: RedmineIssueHistoryRelations.FOLLOWS,
  },
  {
    valueId: RedmineIssueHistoryRelations.DUPLICATES,
  },
  {
    valueId: RedmineIssueHistoryRelations.RELATES,
  },
];
